import {getMetadata,
  getUser,
searchUser} from '../../src/core/localstorage-data';
import {
  bannerDetailInfo,
  orderDetailInfo,
  producDetailInfo,
  storeDetailInfo,
} from './types';
import {eventNames} from './constants';
import {useAppSelector} from '../redux/hooks';
import {lmrCheckedData} from '../redux/orderSlice';
declare const window: any;

export const setUserUniqueId = (UNIQUE_ID: string) => {
  window.Moengage.add_unique_user_id(UNIQUE_ID);
};
export const setlmrStatus = (lmrstatus: boolean) => {
  window.Moengage.add_user_attribute('lmrloginstatus', lmrstatus);
};

export const setLmrFirstVisistStatus = (loginstatus: boolean) => {
  window.Moengage.add_user_attribute('lmrFirstLoginStatus', loginstatus);
};

export const userAttributes = (userDetail: searchUser, phoneNo: string) => {
  window.Moengage.add_first_name(userDetail.firstName);

  window.Moengage.add_user_name(userDetail.firstName); // Full name for user
  window.Moengage.add_mobile(phoneNo);
  window.Moengage.add_birthday(userDetail.dob);
  window.Moengage.add_user_attribute('LMR ID', userDetail.cardNumber); // string value
  window.Moengage.add_user_attribute('pointToExpire', userDetail.pointToExpire); // numeric value
  window.Moengage.add_user_attribute('LMRPOINTS', userDetail.pointsAvailable);

  if (userDetail.lastName != null) {
    window.Moengage.add_last_name(userDetail.lastName);
  }
  if (userDetail.email != null) {
    window.Moengage.add_email(userDetail.email);
  }
  if (userDetail.gender != null) {
    window.Moengage.add_gender(userDetail.gender);
  }
  if (userDetail.validity != null) {
    window.Moengage.add_user_attribute(
      'EDGE Membership Renewal Date',
      userDetail.validity,
    );
  }
};

export const setPageName = (name: string) => {
  window.dataLayer.push({
    pageName: name,
    event: 'pageTitleEvent',
  });
};

export const gtmRewardPoint = (fetchPointDetail: searchUser) => {
  const date = new Date(Date.now());
  const currentMonth = date.toDateString().split(' ');
  window.dataLayer.push({
    rewardPoints: fetchPointDetail.pointsAvailable,
    lmrID: fetchPointDetail.cardNumber,
    lmrPointToExpire: fetchPointDetail.pointToExpire,
    lmrPointExpiryMonth: currentMonth[1].toString(),
    event: 'landmarkRewardPointEvent',
  });
};

export const scanBarocodeGtmData = (productDetail: producDetailInfo) => {
  window.dataLayer.push({
    scan_Code_Number: productDetail.scan_Code_Number,
    product_Name: productDetail.product_Name,
    price: productDetail.price,
    product_ID: productDetail.product_ID,
    //order_Address_City:string;
    //first_Name: productDetail.first_Name,
    //last_Name:string;
    //category_Name:string;
    //category_Type:string;
    brand: productDetail.brand,
    size: productDetail.size,
    stock_Status: productDetail.stock_Status,
    eventName: productDetail.eventName,
    event: productDetail.event,
  });
};
export const checkoutGtmData = (productDetail: orderDetailInfo) => {
  window.dataLayer.push({
    product_ID: productDetail.product_ID,
    product_Name: productDetail.product_Name,
    price: productDetail.price,
    brand: productDetail.brand,
    orderID: productDetail.orderID,
    eventName: productDetail.eventName,
    event: productDetail.event,
    payment_Mode: productDetail.payment_Mode,

    //order_Address_City:string;
    // first_Name: string;
    //last_Name:string;
    //category_Name:string;
    //category_Type:string;
    //purchaseDate?: string | null;

    //billingTime?: string | null;
  });
};
export const whatsAppGtmStatus = (whatsappStatus: string) => {
  window.dataLayer.push({
    whatsappOptinStatus: whatsappStatus,
    event: eventNames.whatsappSignUp,
  });
};

export const storeCodeGtmData = (storeDetail: storeDetailInfo) => {
  window.dataLayer.push({
    storecode: storeDetail.storecode,
    storeaddress: storeDetail.storeaddress,
    storecitypincode: storeDetail.storecitypincode,
    store_name: storeDetail.store_name,
    entity: storeDetail.entity,

    event: storeDetail.event,
  });
  //  console.log('sss');
};

export const bannerDetailGtmData = (BannerDetail: bannerDetailInfo) => {
  window.dataLayer.push({
    bannerId: BannerDetail.bannerId,
    eventName: BannerDetail.eventName,
    event: BannerDetail.event,
  });
};

export const walletOfferClickedEvent = (
  offerQrCode: string | null,
  promotionid: string | null,
) => {
  window.dataLayer.push({
    walletOfferQrCode: offerQrCode,
    promotionId: promotionid,
    event: eventNames.offerEvent,
  });
};

export const finalOrderPayment = (orderPrice: string | null) => {
  window.dataLayer.push({
    TotalOrderPricePaid: orderPrice,
    event: eventNames.orderPaymentDoneEvent,
  });
};
export const loginMoengageEvent = (
  phoneNo: string | null,
  lmrid: string | null,
) => {
  window.dataLayer.push({
    phoneNumber: phoneNo,
    lmrID: lmrid,
    event: eventNames.loginEvent,
  });
};

export const loginEventGA = (
  storeKeyId: string | null,
  storeCode: string | null,
  phoneNo: string | null,
  lmrid: string | null,
  tier: string | null,
  storeName: string| null,
) => {
  window.dataLayer.push({
    storeKeyId: storeKeyId,
    storecode: storeCode,
    phoneNumber: phoneNo,
    lmrID: lmrid,
    tier: tier,
    storeName:storeName,
    event: eventNames.loginEventGA,
  });
};

export const addToCartEventGA = (item: any) => {
  let price = item.priceList[0].sellPrice;
  if (
    item.priceList[0].extSellPrice !== null &&
    item.priceList[0].sellPrice !== item.priceList[0].extSellPrice
  ) {
    price = item.priceList[0].extSellPrice;
  }
  window.dataLayer.push({
    currency: 'INR',
    value: price,
    item: item,
    event: 'addToCartEventGA',
  });
};

export const removeFromCartEventGA = (item: any) => {
  let price = item.sellPrice;
  if (item.extSellPrice !== null && item.sellPrice !== item.extSellPrice) {
    price = item.extSellPrice;
  }
  window.dataLayer.push({
    currency: 'INR',
    value: price,
    item: item,
    event: 'removeFromCartEventGA',
  });
};

export const beginCheckoutEventGA = (order: any) => {
  let totalMRP = 0;
  const BAG_PRICE = 0;
  let promoDiscountAmount = 0;
  let bagPrice = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      totalMRP += item.sellPrice;
      promoDiscountAmount += item.promoDiscountAmount;
    });
  if (order && order.carryBagItem) {
    bagPrice = BAG_PRICE * order.carryBagItem.quantity;
  }
  let couponTotalDiscount = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      if (item.couponDiscountAmount) {
        couponTotalDiscount += item.couponDiscountAmount;
      }
    });
  // let freeBiePrice = 0;
  // if (orderResp && orderResp.selectedFreeBie) {
  //   freeBiePrice += orderResp.selectedFreeBie.extSellPrice;
  // }
  // let lmrRewardsPrice = 0;
  // if (lmrChecked) {
  //   if (priceDetails) {
  //     lmrRewardsPrice = priceDetails.lmrRewardsPrice;
  //   } else {
  //     lmrRewardsPrice = customerProfileData.pointsAvailable * 0.6;
  //   }
  // } else {
  //   lmrRewardsPrice = 0;
  // }

  const totalAmount =
    order && order.itemList
      ? order.itemList.reduce((prevAmount, item) => {
          return prevAmount + item.extSellPrice;
        }, 0)
      : 0;
  // if (priceDetails) {
  //   totalAmount = priceDetails.totalAmount;
  // } else {
  //   totalAmount = totalAmount + bagPrice - lmrRewardsPrice;
  // }
  window.dataLayer.push({
    currency: 'INR',
    value: totalAmount,
    item: order.itemList,
    orderId: order.orderId,
    paymentOrderId: order.orderId,
    storeCode: order.storeCode,
    storeKeyId: order.storeKeyId,
    appliedCoupon: order.appliedCoupon,
    event: 'beginCheckoutEventGA',
  });
};

export const purchaseEventGA = (
  transactionId: string,
  order: any,
) => {let totalMRP = 0;
  const BAG_PRICE = 0;
  let promoDiscountAmount = 0;
  let bagPrice = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      totalMRP += item.sellPrice;
      promoDiscountAmount += item.promoDiscountAmount;
    });
  if (order && order.carryBagItem) {
    bagPrice = BAG_PRICE * order.carryBagItem.quantity;
  }
  let couponTotalDiscount = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      if (item.couponDiscountAmount) {
        couponTotalDiscount += item.couponDiscountAmount;
      }
    });
  const totalAmount =
    order && order.itemList
      ? order.itemList.reduce((prevAmount, item) => {
          return prevAmount + item.extSellPrice;
        }, 0)
      : 0;
  window.dataLayer.push({
    transactionId: transactionId,
    appliedCoupon: "NA", // to be changed
    currency: 'INR',
    totalPricePaid: totalAmount,
    item: order.itemList,
    event: 'purchaseEventGA',
  });
};

export const viewPromotionEventGA = (
  promotionName: string,
  desc: string,
  customerCouponId: number,
) => {
  window.dataLayer.push({
    promotionName: promotionName,
    couponDesc: desc,
    customerCouponId: customerCouponId,
    event: 'viewPromotionEventGA',
  });
};

export const beginFeedback = (orderId:any,phoneNumber:string|null) =>{
  window.dataLayer.push({
    orderId:orderId,
    phoneNumber:phoneNumber,
    event:'beginFeedback',
  })
}

export const submitFeedback = (feedback:string | null,orderId:any,phoneNumber:string | null)=>{
  window.dataLayer.push({
    feedback:feedback,
    orderId:orderId,
    phoneNumber:phoneNumber,
    event:'submitFeedback',
  })
}

export const beginPayment = (order:any) => {
  let totalMRP = 0;
  const BAG_PRICE = 0;
  let promoDiscountAmount = 0;
  let bagPrice = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      totalMRP += item.sellPrice;
      promoDiscountAmount += item.promoDiscountAmount;
    });
  if (order && order.carryBagItem) {
    bagPrice = BAG_PRICE * order.carryBagItem.quantity;
  }
  let couponTotalDiscount = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      if (item.couponDiscountAmount) {
        couponTotalDiscount += item.couponDiscountAmount;
      }
    });
  const totalAmount =
    order && order.itemList
      ? order.itemList.reduce((prevAmount, item) => {
          return prevAmount + item.extSellPrice;
        }, 0)
      : 0;

  window.dataLayer.push({
    orderId:order.orderId,
    items:order.itemList,
    value: totalAmount,
    event: 'beginPayment',
  })
}

export const failedPayment = (order:any) => {
  console.log("orderId",order);
  let totalMRP = 0;
  const BAG_PRICE = 0;
  let promoDiscountAmount = 0;
  let bagPrice = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      totalMRP += item.sellPrice;
      promoDiscountAmount += item.promoDiscountAmount;
    });
  if (order && order.carryBagItem) {
    bagPrice = BAG_PRICE * order.carryBagItem.quantity;
  }
  let couponTotalDiscount = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      if (item.couponDiscountAmount) {
        couponTotalDiscount += item.couponDiscountAmount;
      }
    });
  
  const totalAmount =
    order && order.itemList
      ? order.itemList.reduce((prevAmount, item) => {
          return prevAmount + item.extSellPrice;
        }, 0)
      : 0;
console.log("itemList",order.itemList)
  window.dataLayer.push({
    orderId:order.orderId,
    items:order.itemList,
    value: totalAmount,
    event: 'failedPayment',
  })
}

export const findMissingSize = (itemCode:string,size:string,color:string,price:number,name:string) => {
  window.dataLayer.push({
    itemCode:itemCode,
    size:size,
    color:color,
    price:price,
    name:name,
    event:'find_missingSize',
  })
}

export const selectSize = (itemCode:string,size:string,color:string|undefined,price:number,name:string,stockStatus:string) => {
  window.dataLayer.push({
    itemCode:itemCode,
    size:size,
    color:color,
    price:price,
    name:name,
    stockStatus:stockStatus,
    event:'select_size',
  })
}

export const notifyAvailability = (itemCode:string[],size:string|null,color:string|null,name:string) => {
  window.dataLayer.push({
    itemCode:itemCode,
    size:size,
    color:color,
    name:name,
    event:'notify_availability',
  })
}

export const referral_eCommerce = (url:string) => {
  window.dataLayer.push({
    redirectedUrl:url,
    event:'referral_ecommerce',
  })
}

export const beginLogin = (storeCode:string,storeName:string,pincode:string) => {
  window.dataLayer.push({
    storeCode:storeCode,
    storeName:storeName,
    pincode:pincode,
    event:'begin_login',
  })
}

export const selectColor = (itemCode:string,size:string|null,color:string|undefined,price:number,name:string,stockStatus:string) => {
  window.dataLayer.push({
    itemCode:itemCode,
    size:size,
    color:color,
    price:price,
    name:name,
    stockStatus:stockStatus,
    event:'select_color',
  })
}